import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import moment, { urlFormat, displayFormat } from 'helpers/moment'
import mediaQueryMatches from 'helpers/mediaQuery'

import listClass from 'components/BetterList/List.scss'
import ListColumn from 'components/BetterList/Column'
import Button from 'components/Button'
import List from 'components/BetterList'
import DateComponent from 'components/Date'

// very odd way of doing things, but unable to return multiple rows for a single row otherwise..
import BeforeRow from 'components/Orders/List/BeforeRow'
import AfterRow from 'components/Orders/List/AfterRow'

import classes from './List.scss'

import MdCancel from 'react-icons/lib/md/cancel'

export class ListHolder extends React.Component {
  constructor (props) {
    super(props)

    this.state = { isMobile: false }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const matches = mediaQueryMatches('medium', 'max') // NOTE: Matches can be undefined, which means it had an error

    if (matches) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  };

  shouldShowCustomer = (props = this.props) => {
    return (props.isAdmin || props.customers.length > 1)
  };

  commitStaging = () => {
    let staging = this.props.staging.map((order, i, a) => {
      if (moment(this.props.date).format() !== moment(order.date).format()) {
        // always commits staging to the current date
        order.date = moment(this.props.date)
      }

      return order
    })

    return this.props.commitStaging(staging)
  };

  getAddNewLink = () => {
    if (this.state.isMobile) return `/pricelist${(this.props.date && `/${moment(this.props.date).format(urlFormat)}` || '')}`

    return `/orders${(this.props.date && `/${moment(this.props.date).format(urlFormat)}` || '')}/new`
  };

  renderHeader = () => {
    const headerClassName = cx({
      [classes['header']]: classes['header']
    })

    return <header className={headerClassName}>
      <div className={classes['header-title']}>
        {this.props.isAdmin && 'Orders' || 'Your Order'}

        <span className={classes['header-title--sub']}>
          <DateComponent {...this.props}
            date={this.props.fields.date.value}
            textFormat={'for delivery on {0}'}
            baseUrl='orders'
            urlAction='list'
          />
        </span>
      </div>

      <div className={classes['header-buttons']}>
        <Button
          element='a'
          options={['green', 'small']}
          href={this.getAddNewLink()}
        >
          Add New Item
        </Button>

        {this.props.isAdmin && (
          <Button
            element='a'
            options={['blue', 'small']}
            href={'/process' + (this.props.date ? '/' + moment(this.props.date).format(urlFormat) : '')}
          >
            Fulfillment View
          </Button>
        )}
      </div>
    </header>
  };

  sortGroup = (a, b) => {
    return a - b
  };

  groupAfter = (o, i, c) => {
    if (o[0].is_staging !== true) return null

    return <tbody>
      <tr className={cx(classes['group--after'])}>
        <ListColumn key={`group-${c.indexOf(o)}:after`} options={['full-width', 'buttons']} colspan={100}>
          <Button options={['green']} callback={this.commitStaging}>
            Create Order
          </Button>

          <Button confirm options={['red']} callback={this.props.wipeStaging}>
            Clear
          </Button>
        </ListColumn>
      </tr>
    </tbody>
  };

  sortList = (a, b) => { // route > customer > product
    return a.route && a.route.name && b.route && b.route.name && a.route.name.localeCompare(b.route.name) ||
      a.customer && a.customer.name && b.customer && b.customer.name && a.customer.name.localeCompare(b.customer.name) ||
      a.product && a.product.name && b.product && b.product.name && a.product.name.localeCompare(b.product.name)
  };

  getRowLink = order => {
    if (order.is_staging) return
    return `/orders/${order.id}/edit/`
  };

  getRowOptions = order => {
    let array = []
    if (order.printed_at && !this.props.isAdmin) array.push('disabled')

    return array
  };

  getRowColumns = (order, index, array) => {
    let isFirstOfCustomer = !array[index - 1] || // no previous order
      order.customer_id !== array[index - 1].customer_id // current order !== previous order's customer

    let columns = []

    if (this.shouldShowCustomer()) {
      columns.push(isFirstOfCustomer && [
        <span className={listClass['column--bold']}>{order.customer.name}</span>,
        this.props.isAdmin && <span className={listClass['column--unimportant']}>Route {order.route.name}</span>
      ])
    }

    columns.push([
      <span className={listClass['column--bold']}>{order.product.name}</span>,
      <span className={listClass['column--unimportant']}>{order.product.sourcing_location}</span>
    ])

    columns.push([
      <span>
        <strong>{order.qty}</strong> {order.uom.shorthand || order.uom.name}
      </span>,
      order.option && order.option.name // may not have an option
    ])

    // only show deletion for non-printed orders
    columns.push([
      (!order.printed_at || this.props.isAdmin) && <Button options={['small', 'red', 'icon']}
        confirm={!order.is_staging}
        message='Delete?'
        callback={(e) => {
          order.is_staging && this.props.destroyStaging(order.id) || this.props.destroyOrder(order.id, { redirect: false })
        }}
      >
        <MdCancel />
      </Button>
    ])

    return columns
  };

  render () {
    const className = cx({
      [classes['collection']]: classes['collection'],
      [classes['collection--three-fifths']]: this.props.partial && classes['collection--three-fifths']
    })

    let columnOptions = [null, 'center', 'minimal']
    if (this.shouldShowCustomer()) columnOptions = [null, null, 'center', 'minimal']

    let headers = ['product', 'qty', '']
    if (this.shouldShowCustomer()) headers = ['customer', 'product', 'qty', '']

    const isPastOrder = moment(new Date()).tz('America/Los_Angeles').startOf('day').isAfter(
      moment(this.props.date).tz('America/Los_Angeles').startOf('day')
    )

    return <div className={className}>
      {this.renderHeader()}

      <List
        collection={this.props.orders.concat(this.props.staging)}
        columnOptions={columnOptions}
        headers={headers}

        stripeByField={'customer_id'}

        renderAfterRow={AfterRow}
        renderBeforeRow={BeforeRow}
        getRowLink={this.getRowLink}
        getRowOptions={this.getRowOptions}
        getRowColumns={this.getRowColumns}
        sort={this.sortList}

        groupBy={o => { // this will also sort them...
          if (o.is_staging) return 1 // 'staging'
          if (o.printed_at) return 3 // 'printed'

          return 2 // 'ordered'
        }}
        groupTitle={o => {
          const first = (o || []).find(o => o)
          if (!first) return null
          if (first.printed_at) return `Fulfill${isPastOrder && 'ed' || 'ing'}`
          if (first.is_staging) return 'Your Cart'
          return 'Ordered'
        }}
        groupDesc={o => {
          const first = (o || []).find(o => o)
          if (!first) return null
          if (first.printed_at) {
            return `${isPastOrder && `We've fulfilled` || `We're fulfilling`} these items.
              ${!isPastOrder && 'To make changes, please call or text us at (415) 275-2292.' || ''}` // TODO: Phone number via settings.
          }

          return null
        }}
        sortGroup={this.sortGroup}
        groupAfter={this.groupAfter}

        noResultsText={`No orders for ${moment(this.props.date).format(displayFormat)}.`}
        noResultsButton={!this.props.partial && <Button
          element='a'
          options={['purple', 'large']}
          href={this.getAddNewLink()}
        >
          Start Your Order
        </Button>}
      />
    </div>
  }
}

ListHolder.propTypes = {
  // state
  staging: PropTypes.array.isRequired,
  orders: PropTypes.array.isRequired,
  pricelist: PropTypes.array.isRequired,
  routes: PropTypes.array,
  customers: PropTypes.array,

  isAdmin: PropTypes.bool,

  // actions
  editStaging: PropTypes.func.isRequired,
  destroyStaging: PropTypes.func.isRequired,
  wipeStaging: PropTypes.func.isRequired,
  commitStaging: PropTypes.func.isRequired,
  destroyOrder: PropTypes.func.isRequired,

  fields: PropTypes.object,

  // from parent
  partial: PropTypes.bool,

  // from params
  date: PropTypes.any,

  // from redux / router
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object,
  location: PropTypes.object
}

ListHolder.defaultProps = {
  partial: false
}

export default ListHolder



// WEBPACK FOOTER //
// ./src/components/Orders/List/List.js